import { DataSource } from "@angular/cdk/collections";
import { Injectable } from "@angular/core";
import { Sort } from "@angular/material/sort";
import { IrReviewReportControllerService,
         IrReviewReportResponse,
         APIResultPageResponseListIrReviewReportResponse
        } from "@set-it-workflow/set-it-workflow-ts-angular";
import { BehaviorSubject, Subscription, combineLatest, Observable } from "rxjs";
import { debounceTime, filter, map } from "rxjs/operators";
import { SearchReportCriteria } from "src/app/model/search-report-criteria.model";

@Injectable({
  providedIn: "root", 
})
export class IrReportService {
  totalIrPages = new BehaviorSubject<number>(0);
  totalIrElements = new BehaviorSubject<number>(0);
  currentPage = new BehaviorSubject<number>(0);
  searchReportCriteria = new BehaviorSubject<SearchReportCriteria>(new SearchReportCriteria());
  searchPage = new BehaviorSubject<number>(0);
  searchPageSize = new BehaviorSubject<number>(10);
  searchSort = new BehaviorSubject<Sort>(null);
  irReportDataSource = new IrReportDataSource();


  private subscription: Subscription;

  constructor(private irReviewReportService: IrReviewReportControllerService) {}

  public startIrSubscribe(): void {
    this.subscription = new Subscription();
    this.subscription.add(
      combineLatest([
        this.searchReportCriteria,
        this.searchPage,
        this.searchPageSize,
        this.searchSort
      ]).pipe(
          debounceTime(200),
          filter((x) => x[0] != null)
        ).subscribe(([searchReportCriteria, page, pageSize, sort]) => {
            this.getIrReport(
              searchReportCriteria.deptId,
              searchReportCriteria.endDate,
              searchReportCriteria.startDate,
              searchReportCriteria.taskCategoryId,
              page,
              pageSize,
              sort
            ).subscribe(
              ([totalPages, totalElements, elements]: [
                number,
                number,
                IrReviewReportResponse[]
              ]) => {
                this.totalIrPages.next(totalPages);
                this.totalIrElements.next(totalElements);
                this.irReportDataSource.update(elements);
              }
            );
        })
    );
  }

  public unSubscription(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  public getIrReport(
    deptId: string,
    endDate: string,
    startDate: string,
    taskCategoryId: number,
    page: number,
    pageSize: number,
    sort: Sort,
  ): Observable<[number, number, IrReviewReportResponse[]]> { 
    return this.irReviewReportService
      .searchIrReviewReportUsingGET(deptId,endDate,page,pageSize,this.sortFieldBy(sort),startDate, taskCategoryId)
      .pipe(
        map((x: APIResultPageResponseListIrReviewReportResponse) => [
          x.data.totalPages,
          x.data.totalElements,
          x.data.elements,
        ])
      );
  }

  public sortFieldBy(sort: Sort): [string]{
    return sort && sort.direction && sort.active ? [this.columnToSortSymbol(sort.active) + ',' + sort.direction] : null;
  }

  public columnToSortSymbol(column: string) {
    switch (column) {
      case "meetingDate":
        return "taskDetail.meetingDate";
      case "buDepartment":
        return "taskDetail.toSupportBusinessDepartment";
      case "itDepartment":
        return "taskDetail.department";
      case "componentName":
        return "component.componentName";
      case "taskId":
        return "taskId";
      case "mainTaskName":
        return "taskName";
    }
  }

  public downLoadFile(data: any, type: string,fileName:string) {

    let blob = new Blob([data], { type: type});
     this.saveAs(blob,fileName);
  }


  public saveAs(blob: any, fileName: any) {
    var url = window.URL.createObjectURL(blob);

    var anchorElem = document.createElement("a");
    anchorElem.href = url;
    anchorElem.download = fileName;

    document.body.appendChild(anchorElem);
    anchorElem.click();
    document.body.removeChild(anchorElem);
    setTimeout(function() {
      window.URL.revokeObjectURL(url);
    }, 1000);
  }
}

export class IrReportDataSource extends DataSource<IrReviewReportResponse> {
  data = new BehaviorSubject<IrReviewReportResponse[]>([]);

  connect(): Observable<IrReviewReportResponse[]> {
    return this.data;
  }

  disconnect(): void {}

  update(x: IrReviewReportResponse[]): void {
    this.data.next(x);
  }
}
